import logo from '../../Images/logo.png';
import darkModeIcon from '../../Images/darkMode.png';
import lightModeIcon from '../../Images/lightMode.png';
import ProfilePhoto from '../../components/UI/profilePhoto';
import React from 'react';
import SideNav from '../SideNav/SideNav';
import {useState, useContext} from 'react';
import ThemeContext from '../../store/theme-context';


const Navbar = () => {

    const theme = useContext(ThemeContext);

    const [sideNavOpen, setSideNavOpen] = useState(false);

    const toggleSideNav = () => {
        setSideNavOpen(!sideNavOpen);
    }

    return ( 
        <React.Fragment>
        <nav className="navbar-container" style={{borderColor: theme.currentTheme.borderColor}}>
            <div onClick={toggleSideNav}>
            <ProfilePhoto className="profileIcon dp-navbar"/>
            </div>
            <img src={logo} alt="website logo" height="50" width="100" />
            
            { theme.currentTheme.type === "light" && <img src={darkModeIcon} className="themeIcon" onClick={theme.onThemeChange} alt="dark mode icon" height="30" width="30" />  }
            { theme.currentTheme.type !== "light" && <img src={lightModeIcon} className="themeIcon" onClick={theme.onThemeChange} alt="dark mode icon" height="32" width="32" />  }
        </nav>
        { sideNavOpen && <SideNav sideNavOpen="sideNavOpen" toggleSideNav={toggleSideNav}/>}
        </React.Fragment>
     );
}
 
export default Navbar;